import { Injectable } from "@angular/core";
import { HttpService } from "./http-service";
import { HttpClient,  HttpHeaders} from '@angular/common/http';
import { Configuracoes } from "../entities/configuracoes";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { map } from "rxjs/operators";
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: "root",
})
export class CreditCardService extends HttpService {
  private url;

  constructor(
    public router: Router,
    public http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
    public toastService: ToastrService
  ) {
    super(http, router, toastService, platformId);
    this.url = Configuracoes.API_GATEWAY_PAGAMENTO_URL;
  }


  OnInit() {}

  public consultaPedido(pedido, callback) {
    return this.http
      .get(`${this.url}/consultapedido/${pedido}`, {
        headers: this.getHeaders(),
      })
      .pipe(map((resp) => resp))
      .subscribe(
        (resp) => {
          callback(resp);
          this.dimissLoading();
        },
        (error) => {
          this.dimissLoading();
        }
      );
  }

  public consultaListaPedido(pedido, callback) {
    return this.get(`${this.url}/consultalistapedido${pedido}`, callback);
  }

  public enviaPedido(payment, callback, callbackErro) {
    return this.post(`transacao`, payment, callback, callbackErro);
  }

  getHeaders() {
    return new HttpHeaders({
      "Content-Type": "application/json",
      token: Configuracoes.apiKeyGatewayPgto,
    });
  }
}
